import { ErrorCode, ErrorName, CustomError } from "./types";

export class ServerError extends Error implements CustomError {
  public message: string;
  public name: string;
  public statusCode: number;
  constructor(message = "") {
    super(message);
    this.message = message;
    this.statusCode = ErrorCode.Error;
    this.name = ErrorName.Error;
  }
}
